import { CommunicationDataType, CommunicationType, EventValueEnum } from "../types/communication/communicationDataType";
import { render } from '@testing-library/react';
import React from "react";


// export const renderRouted = (cmp) => render(<BrowserRouter>{cmp}</BrowserRouter>);
export const renderRouted = (cmp: any) => render(React.createElement(cmp));

export const initialStateRealtime = {
	communicationData: new CommunicationDataType()
};

export const mockComm: any = {
	"_id": "63df5def46f4c8ef07ae5fb8",
	"to": "+393896896125",
	"content": "Abbiamo rilevato un possibile incidente al tuo veicolo targato $(plate). Verifica la segnalazione entro 48 ore qui: [[BASE_URL]]/[[TOKEN]]",
	"placeholderValues": {
		"plate": "CJ402SP"
	},
	"company_code": 99,
	"type": "SIN_INAT",
	"hrm_message_id": "5187724292",
	"inc_utc_time": "2023-01-07T13:47Z",
	"inc_data": "07/01/2023",
	"disable_step_10": true,
	"assic_cfpiva": "GRGPTR47S21F376B",
	"comp_agenzia_nome": "FASANO",
	"comp_indirizzo": "CORRADO S.A.S. DI CORRADO PIERLUIGI",
	"crash_id": "AA_B_CRASH_ID",
	"assic_cognome": "CRISTAURO",
	"assic_stato": "ITALIA",
	"comp_polizza": "130892868",
	"comp_agenzia_code": "39243",
	"assic_indirizzo": "Contrada Carbonelli, 29, 72015 Fasano BR, Italia",
	"assic_email": "",
	"assic_cap": "72015",
	"veic_targa": "CJ402SP",
	"cai_side": "A",
	"tel_o_mail": "0804413774",
	"comp_certificato_dal": "19/01/2022",
	"main_impact_point": "BOTTOM-CENTER",
	"inc_luogo": "ND, ND Monopoli BA",
	"update_date": "2023-01-07T15:02:33.809",
	"comp_agenzia_denominazione": "CORRADO S.A.S. DI CORRADO PIERLUIGI",
	"inc_latitude": 40.870968,
	"comp_certificato_al": "19/01/2023",
	"cp_veic_targa": "CS821MD",
	"correlated_crash_id": "AA_B_CTP_CRASH_ID",
	"assic_nome": "FEDERICA",
	"phone_number": "3347385621",
	"inc_longitude": 17.351318,
	"assic_tel_o_email": "3347385621",
	"creation_date": "2024-01-07T14:02:33.965Z",
	"token": "AA_B",
	"altriVeicoliInfo": {
		"isPresent": "N",
		"contactList": []
	},
	"baremeFreeDescription": "",
	"baremeInfo": {
		"id": "15",
		"description": "La controparte invadeva la sede stradale riservata alla circolazione in senso inverso",
		"carInvolved": "CTP",
		"assInRetro": false,
		"ctpInRetro": false
	},
	"baremeResponses": {
		"Q1_Answer": "fronte-ns",
		"Q2_Answer": "fronte-ctp",
		"Q3_13_Answer": "ctp"
	},
	"conducenteInfo": {
		"alsoOwner": "Y",
		"y_contactInfo": {
			"_id": "",
			"name": "BO",
			"surname": "BO",
			"phoneNumber": "",
			"email": "mario.fornaroli84@gmail.com",
			"targa": "",
			"nameSurname": "",
			"description": ""
		},
		"n_contactInfo": {
			"_id": "",
			"name": "",
			"surname": "",
			"phoneNumber": "",
			"email": "",
			"targa": "",
			"nameSurname": "",
			"description": ""
		}
	},
    "authConfirmPrivacyChecked": true,
    "linearConducenteInfo": {
        "insuredIsDriver": false,
        "conducente_contactInfo": {
            "name": "Mario",
            "surname": "Fornaroli",
            "phoneNumber": "11111111111"
        }
    },
    "linearControparteInfo": {
        "agreeWithCtp": false,
        "agree_contactInfo": {
            "name": "Mario",
            "surname": "Fornaroli",
            "phoneNumber": "11111111111"
        }
    },
	"controparteInfo": {
		"y_ctp_contactInfo": {
			"_id": "",
			"name": "SEBASTIANO",
			"surname": "MANZELLA",
			"phoneNumber": "",
			"email": "giorgiogiuseppe8@gmail.com",
			"targa": "",
			"nameSurname": "",
			"description": ""
		},
		"n_ctp_contactInfo": {
			"_id": "",
			"name": "",
			"surname": "",
			"phoneNumber": "",
			"email": "",
			"targa": "",
			"nameSurname": "",
			"description": ""
		},
		"dn_ctp_contactInfo": {
			"_id": "",
			"name": "",
			"surname": "",
			"phoneNumber": "",
			"email": "",
			"targa": "",
			"nameSurname": "",
			"description": ""
		}
	},
	"cp_compagnia_assic": "UNIPOLSAI ASSICURAZIONI S.p.A. *",
	"ctp_zoneUrto": [
		{
			"position": "BOTTOM-CENTER",
			"isSelected": true
		}
	],
	"events": [
		{
			"timestamp": "2023-02-06T09:02:28.005Z",
			"value": "CAI_FILLING_START"
		},
		{
			"timestamp": "2023-02-06T09:02:34.934Z",
			"value": "CAI_FILLING_START"
		},
		{
			"timestamp": "2023-02-06T09:02:39.351Z",
			"value": "is_rca"
		},
		{
			"timestamp": "2023-02-06T09:14:36.028Z",
			"value": "is_rca"
		},
		{
			"timestamp": "2023-02-06T09:28:33.903Z",
			"value": "CAI_FILLING_START"
		},
		{
			"timestamp": "2023-02-06T09:28:37.420Z",
			"value": "is_rca_many"
		}
	],
	"feritiInfo": {
		"contactList": []
	},
	"forceLastPathname": "end-signature-many-vehicles",
	"fotoContestoList": [],
	"interactions": [],
	"lastPathname": "/AA_B/end-signature-many-vehicles",
	"numOfPasssengers": 0,
	"numOfVeichles": 3,
	"oggettiDiversiInfo": {
		"contactList": []
	},
	"rimorchioInfo": {
		"trainavaRimorchio": "N",
		"targa": "",
		"stato_immatricolazione": ""
	},
	"testimoniInfo": {
		"contactList": []
	},
	"update_at": "2023-02-06T10:28:49.623+01:00",
	"zoneUrto": [
		{
			"position": "BOTTOM-CENTER",
			"isSelected": true
		}
	],
	"baremeUserChoise": "BAREME_QUESTIONS_FILLED_ACCEPTED"
}

export const mockCommLinear: any = {
	...mockComm,
    "authConfirmPrivacyChecked": true,
    "linearConducenteInfo": {
        "insuredIsDriver": false,
        "conducente_contactInfo": {
            "name": "Mario",
            "surname": "Fornaroli",
            "phoneNumber": "11111111111"
        }
    },
    "linearControparteInfo": {
        "agreeWithCtp": false,
        "agree_contactInfo": {
            "name": "Mario",
            "surname": "Fornaroli",
            "phoneNumber": "11111111111"
        }
    },
    "companyName": "LINEAR"
}

export const mockCommLinearEvents: any = {
	...mockCommLinear,
    "events": [{
        receiving_timestamp: "",
        timestamp: "",
        value: EventValueEnum.LINEAR_SEND_DOCUMENTS,
        env: "",
        metadata: { }
    }]
}

export const axios_resp_generic_SUCCESS = {
	data: {
		opResult: true,
		data: {}
	}
};

export const axios_resp_comm_SUCCESS = {
	data: {
		opResult: true,
		data: {
			communication: new CommunicationType()
		}
	}
};

export const axios_resp_generic_ERROR = {
	data: {
		opResult: false,
		data: {}
	}
};

export const noob = () => { }

export const mockSelectData = {
	setValue: noob,
	options: [],
	name: "",
	placeholder: "Seleziona"
}

export const mockInputData = {
	setValue: noob,
	value: "",
	name: "",
	placeholder: "Seleziona"
}

export const mockTableCellData = {
	preFileType: "",
    zoneItem: {
		isSelected: false
	},
    zoneItemSelected: noob,
    zoneFotoAdded: noob,
    zoneFotoRemove: noob,
    removeZone: noob
}


export class LocalStorageMock {
	private store: any = {}
	constructor() {
	  this.store = {};
	}
  
	clear() {
	  this.store = {};
	}
  
	getItem(key: string) {
	  return this.store[key] || null;
	}
  
	setItem(key: string, value: any) {
	  this.store[key] = value.toString();
	}
  
	removeItem(key: string) {
	  delete this.store[key];
	}
  }
